export default "__VITE_ASSET__CbJcU$8p__"